import {post, get, del} from '@/utils/request'

// 查询冻结金分类数量
export function freezeFeeTypeGroupNums(data) {
    return post({
        data,
        url: 'tbs/fdContract/freezeFeeTypeGroupNums'
    })
}
// 冻结金列表
export function freezeFeelist(data) {
    return post({
        data,
        url: 'tbs/fdContract/freezeFeelist'
    })
}
// 查询冻结金详情-冻结金信息
export function freezeFeeDetailFreezeInfo(data) {
    return post({
        data,
        url: 'tbs/fdContract/freezeFeeDetailFreezeInfo'
    })
}
// 查询冻结金详情-解冻明细
export function freezeFeeDetailunfreezeDetail(data) {
    return post({
        data,
        url: 'tbs/fdContract/freezeFeeDetailunfreezeDetail'
    })
}
// 查询冻结金详情-扣款明细
export function freezeFeeDetailWithholdDetail(data) {
    return post({
        data,
        url: 'tbs/fdContract/freezeFeeDetailWithholdDetail'
    })
}
// 查询冻结金详情-冻结日志
export function getFillLogList(data) {
    return post({
        data,
        url: 'tbs/fdContract/getFillLogList'
    })
}